import React, { useEffect, useState } from "react";
import { Col, Row, Space, Table, Typography } from "antd";

import { pmtRefraction } from "./config";
import { useAppSelector } from "redux/hooks";
import { infoDetailsProps } from "types/models/infoDetailsProps";
import { selectedData } from "types/config/dry-refraction";
import { data6Col } from "../../config";
import { dryRefractionTb1 } from "../../DryRefraction/config";
const PmtRefractionDtosPrint = ({data}) => {

  const [dataDryRefractionPrint, setDataDryRefractionPrint] = useState({
    left: data6Col,
    right: data6Col,
  });
  //left
  useEffect(() => {
    if (
      data &&
      data?.left &&
      data?.left?.tb1 &&
      (data?.left?.tb1?.sph ||
        data?.left?.tb1?.cyl ||
        data?.left?.tb1?.axis ||
        data?.left?.tb1?.ucva ||
        data?.left?.tb1?.va ||
        data?.left?.tb1?.vision)
    ) {
      setDataDryRefractionPrint((pre) => ({
        ...pre,
        left: [
          {
            key: 1,
            none: "Xa",
            ucva:
              data?.left?.tb1?.ucva && data?.left?.tb1?.ucva[0],
            sph: data?.left?.tb1?.sph && data?.left?.tb1?.sph[0],
            cyl: data?.left?.tb1?.cyl && data?.left?.tb1?.cyl[0],
            axis:
              data?.left?.tb1?.axis && data?.left?.tb1?.axis[0],
            vision:
              data?.left?.tb1?.vision &&
              data?.left?.tb1?.vision[0],
            va: data?.left?.tb1?.va && data?.left?.tb1?.va[0],
          },
          {
            key: 2,
            none: "Add",
            ucva:
              data?.left?.tb1?.ucva && data?.left?.tb1?.ucva[1],
            sph: data?.left?.tb1?.sph && data?.left?.tb1?.sph[1],
            cyl: data?.left?.tb1?.cyl && data?.left?.tb1?.cyl[1],
            axis:
              data?.left?.tb1.axis && data?.left?.tb1?.axis[1],
            vision:
              data?.left?.tb1?.vision &&
              data?.left?.tb1?.vision[1],
            va: data?.left?.tb1?.va && data?.left?.tb1?.va[1],
          },
          {
            key: 3,
            none: "Gần",
            ucva:
              data?.left?.tb1?.ucva && data?.left?.tb1?.ucva[2],
            sph: data?.left?.tb1?.sph && data?.left?.tb1?.sph[2],
            cyl: data?.left?.tb1?.cyl && data?.left?.tb1?.cyl[2],
            axis:
              data?.left?.tb1?.axis && data?.left?.tb1?.axis[2],
            vision:
              data?.left?.tb1?.vision &&
              data?.left?.tb1?.vision[2],
            va: data?.left?.tb1?.va && data?.left?.tb1?.va[2],
          },
        ],
      }));
    } else
      setDataDryRefractionPrint((pre) => ({
        ...pre,
        left: data6Col,
      }));
    // right
    if (
      data &&
      data?.right &&
      data?.right?.tb1 &&
      (data?.right?.tb1?.sph ||
        data?.right?.tb1?.cyl ||
        data?.right?.tb1?.axis ||
        data?.right?.tb1?.ucva ||
        data?.right?.tb1?.va ||
        data?.right?.tb1?.vision)
    ) {
      setDataDryRefractionPrint((pre) => ({
        ...pre,
        right: [
          {
            key: 1,
            none: "Xa",
            ucva:
              data?.right?.tb1?.ucva && data?.right?.tb1?.ucva[0],
            sph:
              data?.right?.tb1?.sph && data?.right?.tb1?.sph[0],
            cyl:
              data?.right?.tb1?.cyl && data?.right?.tb1?.cyl[0],
            axis:
              data?.right?.tb1?.axis && data?.right?.tb1?.axis[0],
            vision:
              data?.right?.tb1?.vision &&
              data?.right?.tb1?.vision[0],
            va: data?.right?.tb1?.va && data?.right?.tb1?.va[0],
          },
          {
            key: 2,
            none: "Add",
            ucva:
              data?.right?.tb1?.ucva && data?.right?.tb1?.ucva[1],
            sph:
              data?.right?.tb1?.sph && data?.right?.tb1?.sph[1],
            cyl:
              data?.right?.tb1?.cyl && data?.right?.tb1?.cyl[1],
            axis:
              data?.right?.tb1.axis && data?.right?.tb1?.axis[1],
            vision:
              data?.right?.tb1?.vision &&
              data?.right?.tb1?.vision[1],
            va: data?.right?.tb1?.va && data?.right?.tb1?.va[1],
          },
          {
            key: 3,
            none: "Gần",
            ucva:
              data?.right?.tb1?.ucva && data?.right?.tb1?.ucva[2],
            sph:
              data?.right?.tb1?.sph && data?.right?.tb1?.sph[2],
            cyl:
              data?.right?.tb1?.cyl && data?.right?.tb1?.cyl[2],
            axis:
              data?.right?.tb1?.axis && data?.right?.tb1?.axis[2],
            vision:
              data?.right?.tb1?.vision &&
              data?.right?.tb1?.vision[2],
            va: data?.right?.tb1?.va && data?.right?.tb1?.va[2],
          },
        ],
      }));
    } else
      setDataDryRefractionPrint((pre) => ({
        ...pre,
        right: data6Col,
      }));
  }, [data]);

  const value = [
    {
      key: 1,
      data: dataDryRefractionPrint.right,
      comment: data?.right?.tb2 && data?.right?.tb2?.comments,
      advice: data?.left?.tb2 && data?.left?.tb2?.advice,
    },
    {
      key: 2,
      data: dataDryRefractionPrint.left,
      comment: data?.left?.tb2 && data?.left?.tb2?.comments,
    },
  ];
  return (
    <div className="dry-refraction-print">
      <Space direction="vertical" style={{ width: "100%" }}>
        <Row gutter={[16, 8]}>
          {value.map((item) => {
            const res = selectedData.find((e) => {
              if (e.value === item.advice) {
                return e.label;
              }
            });
            return (
              <Col span={12} key={item.key}>
                <Space direction="vertical">
                  <Typography.Text style={{ fontWeight: "bold" }}>
                    Khúc xạ chủ quan PMT:
                  </Typography.Text>
                  <Table
                    dataSource={item.data}
                    columns={dryRefractionTb1}
                    bordered={true}
                    pagination={false}
              className="table-print"

                  />
                  {item?.comment && (
                    <Row>
                      <Typography
                        style={{ fontWeight: "bold", paddingRight: "5px" }}
                      >
                        Nhận xét:
                      </Typography>
                      <Typography.Text>
                        {item.comment}
                      </Typography.Text>
                    </Row>
                  )}
                  {item?.advice && (
                    <Row>
                      <Typography
                        style={{ fontWeight: "bold", paddingRight: "5px" }}
                      >
                        Lời khuyên:
                      </Typography>
                      <Typography.Text
                      >
                        {res?.label}
                      </Typography.Text>
                    </Row>
                  )}
                </Space>
              </Col>
            );
          })}
        </Row>
      </Space>
    </div>
  );
};

export default PmtRefractionDtosPrint;
